import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
const Footer = () => {

  const contactInfo =  useStaticQuery(graphql`
    query ContactInfoQuery {
      allDatoCmsContact {
        edges {
          node {
            heroImage {
              gatsbyImageData(placeholder:DOMINANT_COLOR)
            }
            email
            phone
            address
          }
        }
      }
    }
  `)

  const data = contactInfo.allDatoCmsContact.edges[0].node;
  const {email, phone} = data;
  return (
    <div id="colophon">
      <div className="line-in" data-scroll></div>
      <div className="inline w-100 mt30">
        <div className="up--arrow ma" data-scroll></div> 
      </div>
      <div className="spacer m-spacer"></div>
      <div className="max-300 mb30 ma text-center uppercase fade-in medium" data-scroll>
         <span className="h6 mr5">A/</span>168a Barry Parade,<br/>Fortitude Valley QLD 4006
      </div>
      <div className="max-300 ma text-center uppercase fade-in delay-50 medium" data-scroll>
        <a className="underline-link no-ul mb5" href={"mailto:"+email}><span className="h6 mr5">E/</span>{email}</a><br/>
        <a className="underline-link no-ul" href={"tel:"+phone}><span className="h6 mr5">P/</span>{phone}</a> 
      </div>

      <div className="spacer m-spacer"></div>
      <div className="footer--bottom small socials uppercase medium text-center p15 fade-in" data-scroll>
        <div className="ma flex space-between" style={{maxWidth: "233px"}}>
          <a className="underline-link no-ul mr20" href="https://www.instagram.com/stemdesignflorals" target="_blank" rel="noreferrer">Instagram</a>
          <a className="underline-link no-ul" href="https://vimeo.com/" target="_blank" rel="noreferrer">Vimeo</a>
          <a className="underline-link no-ul ml20" href="https://www.facebook.com/stemdesignflorals" target="_blank" rel="noreferrer">Facebook</a> 
        </div>
      </div>
      <div className="line-in" data-scroll></div>
      <div className="footer--bottom uppercase medium small fade-in delay-100" data-scroll>
        <div className="inner flex p15 m-wrap">
          <p className="m0 mra w-200p m-hide">©stemdesign { new Date().getFullYear()}</p>
          <p className="m0 m-ma">Stem design <span className="h6 ml10 mr10 lowercase">by</span> nicole cooper</p> 
          <p className="m0 mla w-200p text-right m-ma m-center">website by <a className="underline-link" href="https://groundcrew.com.au">groundcrew</a></p>
        </div>
      </div>
    </div> 
  )
} 

export default Footer

